__turbopack_context__.v({
  "button": "Button-module__iYV4-q__button",
  "lg": "Button-module__iYV4-q__lg",
  "primary": "Button-module__iYV4-q__primary",
  "quiet": "Button-module__iYV4-q__quiet",
  "secondary": "Button-module__iYV4-q__secondary",
});
